import cn from 'classnames';
import { ComponentProps, FC, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/shared/ui';

import { RecordingsTimeline } from '../RecordingsTimeline';

import styles from './HiddenRecordings.module.scss';

type HiddenRecordingsProps = Omit<
  ComponentProps<typeof RecordingsTimeline>,
  'hideMode'
> & {
  count: number;
};

export const HiddenRecordings: FC<HiddenRecordingsProps> = ({
  count,
  className,
  ...timelineProps
}) => {
  const { formatMessage } = useIntl();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section
      className={cn(styles.container, className)}
      data-section="patient-recordings-hidden"
    >
      <Button
        variant="tertiary"
        icon={isExpanded ? 'eye' : 'eyeClosed'}
        className={styles.toggle}
        onClick={() => setIsExpanded((current) => !current)}
      >
        {isExpanded
          ? formatMessage({
              id: 'patientRecordings.hideHidden',
              defaultMessage: 'Collapse archived recordings',
            })
          : formatMessage(
              {
                id: 'patientRecordings.showHidden',
                defaultMessage: 'Show archived recordings ({count, number})',
              },
              { count },
            )}
      </Button>

      {isExpanded && (
        <>
          <h4 className={cn('h4', styles.title)}>
            {formatMessage({
              id: 'patientRecordings.archivedTitle',
              defaultMessage: 'Archived recordings',
            })}
          </h4>
          <RecordingsTimeline {...timelineProps} hideMode />
        </>
      )}
    </section>
  );
};
